import { useEffect, useState } from "react";
import {
  CustomFilterUnion,
  CustomFilterConfig,
  CFSelectItemSetting,
  CFChangeEvent,
} from "./types";
import { f } from "../../../util/f";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../select/Select";

export default function CustomFilterSelectItem<
  C extends CustomFilterUnion,
>(props: {
  config: CustomFilterConfig<C>;
  filterEvent: (event: CFChangeEvent) => void;
  settings: CFSelectItemSetting;
}) {
  // destruction!
  const { config, filterEvent, settings } = props;
  const values =
    config.component.type === "select" ? config.component.values : [];
  const value = settings?.selectedValue
    ? values.find((v) => v.value === settings.selectedValue) || values[0]
    : values[0];

  // state of things
  const [selectedValue, setSelectedValue] = useState(value);

  // because everybody loves effects!
  useEffect(() => {
    // pseudo selectEvent

    let selectValue = selectedValue.value;

    if (config.dataType === "boolean") {
      selectValue = JSON.parse(selectedValue.value);
    }
    const filterSettings: CFSelectItemSetting = {
      selectedValue: selectValue,
    };

    const event: CFChangeEvent = {
      filterString: f<any>()
        .addFilter(config.queryKey, {
          eq: selectValue,
        })
        .build(),
      filterObj: {
        [config.queryKey]: {
          eq: selectValue,
        },
      },
      filterSettings: filterSettings,
    };

    filterEvent(event);

    // no dependencies on purpose, this effect should ONLY run on first render
    // disable linting because react ...

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handler
  function selectEventHandler(selectValue: string) {
    if (!selectValue) {
      selectValue = selectedValue.value;
    }

    if (config.dataType === "boolean") {
      selectValue = JSON.parse(selectValue);
    }

    const filterSettings: CFSelectItemSetting = {
      selectedValue: selectValue,
    };

    const event: CFChangeEvent = {
      filterString: f<any>()
        .addFilter(config.queryKey, {
          eq: selectValue,
        })
        .build(),
      filterObj: {
        [config.queryKey]: {
          eq: selectValue,
        },
      },
      filterSettings: filterSettings,
    };

    filterEvent(event);
  }

  return (
    <div className="c-custom-filter__content">
      <Select
        defaultValue={selectedValue.value}
        onValueChange={(value: string) => {
          const v = values.find((q) => q.value === value);
          if (v) {
            selectEventHandler(v.value);
            setSelectedValue(v);
          }
        }}
      >
        <SelectTrigger
          placeholder={`Vælg ${config.displayName.toLocaleLowerCase()}`}
        />
        <SelectContent small>
          {values.map((p) => {
            return (
              <SelectItem value={p.value} key={p.value}>
                {p.displayName}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
